/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ChatCommunicationMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler 
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ChatCommunicationMessageHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(
		this,com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION
	);

	/** @type {object} */
	this.xssModule = require("xss");
};
$hxClasses[
	'com.inq.flash.client.control.messagehandlers.ChatCommunicationMessageHandler'
] = com.inq.flash.client.control.messagehandlers.ChatCommunicationMessageHandler;

/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.ChatCommunicationMessageHandler.__name__ = [
	"com","inq","flash","client","control","messagehandlers","ChatCommunicationMessageHandler"
];

/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.ChatCommunicationMessageHandler.__super__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
for ( var k in com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype ) {
	com.inq.flash.client.control.messagehandlers.ChatCommunicationMessageHandler.prototype[k] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k];
}

/**
 * processMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * override public function processMessage(message:Message):Void
 * @override
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ChatCommunicationMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message 
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatCommunicationMessageHandler.prototype.processMessage = function(message) {
	/** @type {?string} */
	var agentName;
	if (message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ALIAS)) {
		agentName = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ALIAS);
	} else {
		agentName = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_AGENT_ALIAS);
	}
	if (!agentName) {
		agentName = com.inq.flash.client.control.FlashVars.getFlashVars().agentName;
	}
	/** @type {string} */
	var clientName = com.inq.flash.client.control.FlashVars.getCustomerName();
	/** @type {object} */
	var expressionObject = com.inq.flash.client.chatskins.SkinControl.checkMessageForSpecialExpression(message);
	/** @type {string} */
	var chatText = expressionObject.text;
	/** @type {?string} */
	var agentId;
	/** @type {boolean} */
	var replay = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY) == "1";
	/** @type {number} */
	var position;
	/** @type {string} */
	var senderName;

	chatText = this.getFilteredText(chatText);

	if (message.getMessageType() == com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_QUEUE) {
		com.inq.flash.client.control.WebRTCMgr.setCallQueue();
		com.inq.flash.client.control.FlashPeer.onQueueWaitMsg();
		if (!replay) {
			this.getController().setFlagChatInQueue(true);
			if (!com.inq.flash.client.control.FlashPeer.getQueueMessagingSpecId()) {
				// Don't process 'chat.communication.queue' message since we already displayed it from the NeedWaitHandler.
				return;
			}
		}
		agentId = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ALIAS);
        if (com.inq.utils.Util.isDefaultAgentAlias()) {
            agentName = com.inq.utils.Util.getConfig("defaultAgentAlias", "&nbsp;");
        }
	} else {
		if (replay) {
			/* If this is a replay and we are returning a queued message
			 * Then, we want to update the message count in the NeedWaitHandler
			 * This must be done, so when we go to a new page and reshow the CI we do not get the first message again
			 */
			com.inq.flash.client.control.messagehandlers.NeedWaitHandler.incrementCounter();
		}
		agentId = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ID);
	}
	var isAgentMessage = !!agentId;

	//in case of a URL in the agent message it will be converted to an anchor tag because for accessibility user URL's has to be in the tab order
	if (isAgentMessage && (chatText.indexOf("http:") >= 0 || chatText.indexOf("https:") >= 0) && chatText.indexOf("href=") == -1) {
		var rex = /https?:\/\/[-\w.]+(:\d+)?(\/([-\w.,;/?:@&=+$%#!~*'()]*(\?\S+)?)?)?/g;
		chatText = chatText.replace(rex, "<a href=\"$&\" target=\"_blank\">$&</a>");
	}

	position = -1;
	if (message.getProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR) != null) {
		position = parseInt(message.getProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR));
	}

	if (message.getProperty(com.inq.flash.client.data.MessageFields.FORM_DATA) == null) {
		senderName = isAgentMessage ? agentName : clientName;
	} else {
		senderName = "";
	}

	if (message.getMessageType() != com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OPENER && !replay) {
		if (message.getMessageType() == com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION) {
			if (isAgentMessage && message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_AUTO_OPENER) !== "true") {
				com.inq.flash.client.control.Incrementality.onInteracted();
				/* If the onInteracted has been performed before, it will return */
				com.inq.flash.client.control.Incrementality.onAgentMsg(chatText);
			} else if (com.inq.flash.client.control.FlashVars.getCustomerName() === senderName) {
				com.inq.flash.client.control.Incrementality.onCustomerMsg(chatText);
			}
		}
		if (isAgentMessage) {
			this.getController().setFlagChatInQueue(false);
			com.inq.flash.client.chatskins.FocusMonitor.startTitlebarFlash();
			com.inq.flash.client.control.MinimizeManager.lastAgentMessage(chatText);
			com.inq.flash.client.chatskins.SndMgr.PlaySound();
		}
	}

	if (replay && isAgentMessage) {
		com.inq.flash.client.control.MinimizeManager.displayAgentMessageAndCount(chatText);
	}

	chatText = this.handleCustomEventAttributes(chatText);

	if (chatText) {
		switch (message.getMessageType()) {
			case com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OUTCOME:
			case com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OPENER:
				com.inq.flash.client.chatskins.SkinControl.AddOpenerToChatWindow(
					agentName,
					chatText,
					com.inq.flash.client.chatskins.ChatTextArea.AGENT,
					position,
					expressionObject.expressionList
				);
				break;
			case com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_SYSTEM:
				/*
				 * RTDEV-17612, RTDEV-19128, RTDEV-20426
				 * Renders TYPE_CHAT_COMMUNICATION_SYSTEM message which was sent from ACIF using
				 * Inq.sendAutomatonMessage(...).  Displaying the system message is handled in ApplicationController.js
				 * @see com.inq.flash.client.control.ApplicationController.prototype.sendAutomatonMessage in
				 * ApplicationController for details.
				 */
				var context = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CONTEXT);
				if (!context || context === "customerInterface") {
					var cssClass = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CSS_CLASS_NAME);
					com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow("", chatText, com.inq.flash.client.chatskins.ChatTextArea.SYSTEM, position, expressionObject.expressionList, replay, cssClass);
				}
				break;
			default:
				// Only renders senderName:chatText
				/** @type {Date} */
				var messageTimestamp = message.getPropertyAsDate(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_TIMESTAMP);
				var cssClass = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_EXTERNAL_APP) ? com.inq.flash.client.chatskins.ChatTextArea.EXTERNAL_AGENT_CLASS_NAME : com.inq.flash.client.chatskins.ChatTextArea.LIVE_AGENT_CLASS_NAME
				this.getController().appendReceivedText(chatText, senderName, position, isAgentMessage, expressionObject.expressionList, replay, cssClass, messageTimestamp);

				if (true === com.inq.flash.client.chatskins.SkinControl.agentImageTypeEnabled && isAgentMessage) {
					com.inq.flash.client.chatskins.SkinControl.setAgentImage(com.inq.flash.client.chatskins.SkinControl.LIVE_AGENT);
				}
		}
	}
    /**
	 *  Agent can send SalsForce Live Chat invocation message.
     */
	if (isAgentMessage && chatText && replay === false) {
        chatText = com.inq.addons.Salesforce.scanMessage(chatText);
    }
	if (message.getProperty(com.inq.flash.client.data.MessageFields.FORM_DATA) != null) {
		this.getController().updateFormFields(message.getProperty(com.inq.flash.client.data.MessageFields.FORM_DATA),message.getProperty(com.inq.flash.client.data.MessageFields.FORM_NAME),message.getProperty(com.inq.flash.client.data.MessageFields.FORM_ID));
	}
};

/** @private @type {com.inq.flash.client.data.Chat} */
com.inq.flash.client.control.messagehandlers.ChatCommunicationMessageHandler.prototype.chat = null;
/** @type {com.inq.flash.client.control.messagehandlers.ChatCommunicationMessageHandler} */
com.inq.flash.client.control.messagehandlers.ChatCommunicationMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ChatCommunicationMessageHandler;
